import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { HeaderManager } from 'inside-out/managers/headerManager';

import { Screener } from 'inside-out/components/shared/screener';

export default class ConsumerScreener extends React.PureComponent {
	static propTypes = {
		location: PropTypes.shape({
			search: PropTypes.string.isRequired,
		}).isRequired,

		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							left_heading: PropTypes.string,
							left_body: PropTypes.string,
							left_link_text: PropTypes.string,
							left_link_url: PropTypes.string,
							right_heading: PropTypes.string,
							right_body: PropTypes.string,
							right_link_text: PropTypes.string,
							right_link_url: PropTypes.string,
						}).isRequired,
					})
				).isRequired,
			}).isRequired,

			screener: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							pages: PropTypes.arrayOf(
								PropTypes.shape({
									question: PropTypes.string.isRequired,
									description: PropTypes.string.isRequired,
									answers: PropTypes.arrayOf(
										PropTypes.shape({
											name: PropTypes.string.isRequired,
											value: PropTypes.string.isRequired,
										})
									),
								})
							),

							results: PropTypes.arrayOf(
								PropTypes.shape({
									rating: PropTypes.string,
									heading: PropTypes.string,
									body: PropTypes.string,
									button_text: PropTypes.string,
									button_url: PropTypes.string,
								})
							),
						}).isRequired,
					})
				).isRequired,
			}).isRequired,

			resources: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.any,
					})
				),
			}),
		}).isRequired,
	};

	componentDidMount = () => {
		HeaderManager.headerProperties = {
			back: false,
			subheader: 'Questionnaire',
		};
	};

	render() {
		const pageSettings = this.props.data.page.edges[0].node;
		const resultPages = this.props.data.resultPages.edges[0].node;
		const { pages } = this.props.data.screener.edges[0].node;

		return (
			<React.Fragment>
				<Helmet title="Screener - For Myself" />

				<Screener
					location={this.props.location}
					type="Consumer"
					resultTiles={pageSettings}
					pages={pages}
					resultPages={resultPages}
					headerManager={HeaderManager}
				/>
			</React.Fragment>
		);
	}
}

export const query = graphql`
	query ConsumerScreenerQuery {
		page: allContentJson(filter: { id: { regex: "/content\\/screener-page\\.json/" } }) {
			edges {
				node {
					left_heading
					left_body
					left_link_text
					left_link_url
					right_heading
					right_body
					right_link_text
					right_link_url
				}
			}
		}

		screener: allScreenersJson(filter: { id: { regex: "/consumer\\.json/" } }) {
			edges {
				node {
					pages {
						question
						description
						answers {
							name
							value
							scoring_value
						}
					}
					results {
						rating
						heading
						body
						button_text
						button_url
					}
				}
			}
		}

		resultPages: allContentJson(
			filter: { id: { regex: "/content\\/consumer-screener-results-page\\.json/" } }
		) {
			edges {
				node {
					Low {
						heading
						body
						button_text
						button_url
						resource_1 {
							...resource
						}
						resource_2 {
							...resource
						}
						resource_3 {
							...resource
						}
						resource_4 {
							...resource
						}
					}
					Medium {
						heading
						body
						button_text
						button_url
						resource_1 {
							...resource
						}
						resource_2 {
							...resource
						}
						resource_3 {
							...resource
						}
						resource_4 {
							...resource
						}
					}
					High {
						heading
						body
						button_text
						button_url
						resource_1 {
							...resource
						}
						resource_2 {
							...resource
						}
						resource_3 {
							...resource
						}
						resource_4 {
							...resource
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/screener/for-myself/index.js